// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1ylan","form":"styles_form__2uRwb"};